import { useEffect } from 'react';
export var useListenerEvent = function useListenerEvent(event, callback, element) {
  useEffect(function () {
    var resolvedElement = typeof element === 'string' ? document.querySelector(element) : element;

    if (resolvedElement) {
      resolvedElement.addEventListener(event, callback);
      return function () {
        resolvedElement.removeEventListener(event, callback);
      };
    }

    return;
  }, [event, element]);
};